import SimpleTable from "../../../../../../components/SimpleTable";
import { useDetailsModal } from "../../../../RetroAdjustment/DetailsModal/useDetailsModal";
import { useColumns } from "./useColumns";

function RetroAdjustments({ data, loading, user, date, canViewRates }) {
    const { open, modal } = useDetailsModal();
    const columns = useColumns({ openDetailsModal: open, user, date, canViewRates });

    return (
        <>
            <SimpleTable
                columns={columns}
                data={data}
                loading={loading}
                footer={false}
            />
            {modal}
        </>
    );
}

export default RetroAdjustments;
